// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListFilter_list-filter__TSS57 {
  margin-top: 96px;
  position: sticky;
  top: calc(var(--navbar-height) + 8px);
  max-height: calc(100vh - var(--navbar-height) - 20px);
  overflow-y: auto;
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  border-top: 3px solid var(--secondary-color);
  background: var(--background-color-2);
}
.ListFilter_list-filter__TSS57 .ListFilter_list-filter__header__we9lV {
  display: flex;
  padding: 16px 0px 8px 0px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-bottom: 1px solid var(--light-grey);
}
.ListFilter_list-filter__TSS57 .ListFilter_list-filter__content__F5ne1 {
  align-self: stretch;
}
.ListFilter_list-filter__TSS57 .ListFilter_title__PZRvv {
  color: var(--text-1);
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.ListFilter_list-filter__TSS57 .ListFilter_clear-filter__SxORU {
  text-transform: initial;
  color: var(--grey-text);
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.ListFilter_list-filter__TSS57 .ListFilter_clear-filter__SxORU svg {
  margin: 0;
}
.ListFilter_list-filter__TSS57 .ListFilter_filter-selected__jnnd7 {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 4px;
}
.ListFilter_list-filter__TSS57 .ListFilter_filter-selected__jnnd7:empty {
  display: none;
}

@media only screen and (max-width: 1200px) {
  .ListFilter_list-filter__TSS57 {
    margin-top: 0;
    border-top: none;
    box-shadow: none;
    padding: 0;
    height: auto;
    position: initial;
    overflow-y: initial;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/ListFilter/ListFilter.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;EACA,qCAAA;EACA,qDAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,4CAAA;EACA,qCAAA;AACF;AAEI;EACE,aAAA;EACA,yBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;AAAN;AAGI;EACE,mBAAA;AADN;AAKE;EACE,oBAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHJ;AAME;EACE,uBAAA;EACA,uBAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAJJ;AAMI;EACE,SAAA;AAJN;AAQE;EACE,aAAA;EACA,eAAA;EACA,YAAA;AANJ;AAQI;EACE,aAAA;AANN;;AAWA;EACE;IACE,aAAA;IACA,gBAAA;IACA,gBAAA;IACA,UAAA;IACA,YAAA;IACA,iBAAA;IACA,mBAAA;EARF;AACF","sourcesContent":[".list-filter {\n  margin-top: 96px;\n  position: sticky;\n  top: calc(var(--navbar-height) + 8px);\n  max-height: calc(100vh - var(--navbar-height) - 20px);\n  overflow-y: auto;\n  display: flex;\n  padding: 16px;\n  flex-direction: column;\n  align-items: flex-start;\n  border-top: 3px solid var(--secondary-color);\n  background: var(--background-color-2);\n\n  .list-filter {\n    &__header {\n      display: flex;\n      padding: 16px 0px 8px 0px;\n      justify-content: space-between;\n      align-items: center;\n      align-self: stretch;\n      border-bottom: 1px solid var(--light-grey);\n    }\n\n    &__content {\n      align-self: stretch;\n    }\n  }\n\n  .title {\n    color: var(--text-1);\n    font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n  }\n\n  .clear-filter {\n    text-transform: initial;\n    color: var(--grey-text);\n    font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n\n    svg {\n      margin: 0;\n    }\n  }\n\n  .filter-selected {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px 4px;\n\n    &:empty {\n      display: none;\n    }\n  }\n}\n\n@media only screen and (max-width: 1200px) {\n  .list-filter {\n    margin-top: 0;\n    border-top: none;\n    box-shadow: none;\n    padding: 0;\n    height: auto;\n    position: initial;\n    overflow-y: initial;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list-filter": `ListFilter_list-filter__TSS57`,
	"list-filter__header": `ListFilter_list-filter__header__we9lV`,
	"list-filter__content": `ListFilter_list-filter__content__F5ne1`,
	"title": `ListFilter_title__PZRvv`,
	"clear-filter": `ListFilter_clear-filter__SxORU`,
	"filter-selected": `ListFilter_filter-selected__jnnd7`
};
export default ___CSS_LOADER_EXPORT___;
